import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import booksData from './data/Books';
import BookCard from './components/BookCard';
import Info from './components/Info';
import Advertising from './components/Advertising.jsx';
import BookReader from './components/BookReader';
import CategoryList from './components/CategoryList';
import FavoriteBooks from './components/FavoriteBooks';
import SearchBar from './components/SearchBar';
import NotFound from "./components/NotFound";

import { Helmet } from "react-helmet";
import './index.css';

function App() {
  const [books, setBooks] = useState(booksData);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const toggleFavorite = (name) => {
    setBooks(books.map(book => 
      book.name === name ? { ...book, isFavorite: !book.isFavorite } : book
    ));
  };

  const filteredBooks = books.filter(book => {
    const matchesSearch = 
      book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      book.author.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = 
      selectedCategory === '' || book.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const categories = [...new Set(books.map(book => book.category))];

  return (
    <>
    <Helmet>
        <title>Читай. Развивайся. Достигай</title>
        <meta name="description" content="Хочешь расти, но не знаешь, с чего начать?  Получи бесплатную подборку книг, которые помогут тебе:
        Стать умнее и продуктивнее
        Освоить новые навыки быстро
        Достигать целей без прокрастинации
        В подборке – только проверенные бестселлеры по саморазвитию, карьере и личной эффективности."/>
    </Helmet>
    <Router>
      <div className="app">
        <header>
          <h1><Link to="/">Читай. Развивайся. Достигай.</Link></h1>
        </header>

        <Routes>
          <Route path="/" element={
            <div className="home-page">
              <SearchBar 
                searchTerm={searchTerm} 
                setSearchTerm={setSearchTerm} 
              />
              
              <div className="main-content">
                <div className="sidebar">
                  <CategoryList 
                    categories={categories} 
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                  />
                  <FavoriteBooks 
                    books={books.filter(book => book.isFavorite).slice(0, 10)} 
                    toggleFavorite={toggleFavorite}
                  />          
                  <Info />
                  <Advertising />
                </div>
                
                <div className="content">
                  <h2>Список книг</h2>
                  <div className="book-grid">
                    {filteredBooks.map(book => (
                      <BookCard 
                        key={book.name} 
                        book={book} 
                        toggleFavorite={toggleFavorite} 
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          } />
          
          <Route path="/book/:name" element={
            <BookReader 
              books={books} 
            />
          } />
          <Route path="*" element={<NotFound/>}  />
        </Routes>
      </div>
    </Router>
    </>
  );
}

export default App;